import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import Modal from 'react-bootstrap/Modal'
import { API_BASE_URL } from '../../config';

const ForgetPassword = (props) => {
    const [state, setState] = useState({
        email: "",

        error: "", loader: false,
    })
    useEffect(() => { 
        if(props.show){
        document.body.classList.add("showModal");
      }
        setState((prev) => ({ ...prev, email: "", error: "" }))
    }, [props.show])
    const handleSubmitClick = (e) => {
        e.preventDefault();
        if (/^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/.test(state.email)) {
            setState((prev) => ({ ...prev, loader: true }))
            var data = new FormData();
            data.append("action", "forgot_user_password")
            data.append("registered_email", state.email)

            const requestOptions = {
                method: 'post',
                body: data
            };
            fetch(API_BASE_URL + 'data_process.php', requestOptions)
                .then((response) => response.json())
                .then(async (responseJson) => {


                    await setState((prev) => ({ ...prev, loader: false }))
                    document.body.classList.remove("showModal")
                    props.handleResponce(responseJson)
                })
                .catch((error) => {

                });
        } else {
            setState((prev) => ({ ...prev, error: 'Please enter valid email' }))
        }
    }
    const handleChange = (e) => {
        setState(prevState => ({
            ...prevState,
            error: ""
        }))
        const { name, value } = e.target
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))


    }

    return (
        <div class={props.show ? "jblListModal modalHere" : "jblListModal"}>
            <div class="jblListModal_Content" style={{ "height": 'auto' }}>
                <div class="jblListModal_header">
                    <span class="close" onClick={() =>{   document.body.classList.remove("showModal"); props.handleClose()}}>&times;</span>
                </div>
                <div className="jblListModal_Body" style={{ "padding": "15px" }}>
                    <p>Forgot Password ?</p>
                    <div className="form_wrapper" >
                        <div className="form_container">
                            <form>
                                <div className="input_field">
                                    <label className="txt_title">Email*</label>
                                    <input type="email" name="email" placeholder="Email" value={state.email} onChange={handleChange} />
                                    <p className={"errormessage"}>{state.error}</p>
                                </div>
                                <div className="siteBtn_box">
                                    <input className="button" type="submit" value="Submit" onClick={handleSubmitClick} disabled={state.loader} style={{ opacity: state.loader ? 0.5 : 1 }} />
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
            <div class={props.show ? "modal-backdrop fade show" : "modal-backdrop fade"}  onClick={() => {document.body.classList.remove("showModal");props.onHide()}}></div>
        </div>
    )
}

//export default Home;
export default withRouter(ForgetPassword);